import { Industry } from "../../constants/V2/industry"

export const getIndustryName = (industry: Industry): string => {
  switch (industry) {
    case Industry.Restaurants:
      return "Restaurants & takeaways"
    case Industry.Cafes:
      return "Cafés & coffee shops"
    case Industry.Bakeries:
      return "Bakeries"
    case Industry.Retail:
      return "Retail stores"
    default:
      return ""
  }
}
